import { FrontendConfig } from "../../models/config"
import { apiInstance } from "../instances/apiInstance"

const configController = {
    get: (): Promise<FrontendConfig> => apiInstance.get("/config").then(response => response.data)
}

export default configController
